import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

/**
 * Bokja fabric drawer (axis a, "view all fabrics").
 *
 * Reuses Horizon's DialogComponent for open/close/scroll-lock/focus-trap. The
 * base class exposes only showDialog()/closeDialog(), and the delegated event
 * system calls the method name verbatim and silently no-ops if it is missing —
 * so, exactly like CartDrawerComponent, we MUST define open()/close() wrappers.
 * We also capture the invoking trigger and restore focus to it on close, because
 * our trigger lives OUTSIDE the component (in the PDP buy column) and the base
 * does not return focus.
 *
 * @extends {DialogComponent}
 */
class FabricDrawerComponent extends DialogComponent {
  /** @type {HTMLElement | null} */
  #lastTrigger = null;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(DialogCloseEvent.eventName, this.#restoreFocus);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(DialogCloseEvent.eventName, this.#restoreFocus);
  }

  /**
   * @param {Event} [event] - the delegated click event (Horizon passes it).
   */
  open(event) {
    const target = /** @type {HTMLElement | undefined} */ (event?.target);
    this.#lastTrigger = target?.closest?.('button') ?? null;
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  #restoreFocus = () => {
    this.#lastTrigger?.focus?.();
    this.#lastTrigger = null;
  };
}

if (!customElements.get('fabric-drawer-component')) {
  customElements.define('fabric-drawer-component', FabricDrawerComponent);
}
